import React from 'react'

export const Banner = ({imagePath, imageAlt}) => {
     console.log(imagePath)
  return (
   
    <div className="banner-container">
    <img className='banner' src={imagePath} alt={imageAlt} />
    </div>
  )
}
